import styled from 'styled-components';
import { colorLink } from '@atlas-frontend/design-tokens';

export const TextLink = styled.a<{ id: string; color?: string }>`
  color: ${({ color }) => color || colorLink} !important;
`;
